import {apiPost} from './client';

export function generateAudioPreview({celebId, wishText}) {
    return apiPost('/celebs/generate-audio-preview', {
        celeb_id: celebId,
        wish_text: wishText,
    });
}
